import { ReactNode, useMemo } from 'react';
import { Element } from 'hast';
import { parseRenderedTable } from '@/features/ai-agents/chat/MarkdownTableVisualization/helpers';
import {
  findDefaultXAxisColumnIndex,
  findNumericColumnIndexes,
  findVariantColumnIndex,
  parseMarkdownTable,
} from '@/features/ai-agents/chat/MarkdownTableVisualization/utils';

export function useTableData(node: Element, children?: ReactNode) {
  const table = useMemo(() => parseMarkdownTable(node), [node]);
  const renderedTable = useMemo(() => parseRenderedTable(children), [children]);
  const numericColumnIndexes = useMemo(
    () => findNumericColumnIndexes(table),
    [table],
  );
  const variantColumnIndex = findVariantColumnIndex(table.headers);
  const isVariantReport = variantColumnIndex >= 0;
  const chartNumericColumnIndexes = numericColumnIndexes.filter(
    (columnIndex) => columnIndex !== variantColumnIndex,
  );
  const defaultXColumnIndex = findDefaultXAxisColumnIndex(
    table.headers.length,
    chartNumericColumnIndexes,
    variantColumnIndex,
  );

  return {
    chartNumericColumnIndexes,
    defaultXColumnIndex,
    isVariantReport,
    renderedTable,
    table,
    variantColumnIndex,
  };
}
